import { z } from 'zod';

const ManfreditesManfrediteStatsSchema = z.object({
  roles: z.array(z.string()),
  mainTechs: z.array(z.string()),
  techs: z.array(z.string()),
  experienceRange: z.string(),
  salaryRange: z.string(),
  wantsRemote: z.boolean(),
  wantsHybrid: z.boolean(),
  wantsFaceToFace: z.boolean(),
  contractTypes: z.array(z.enum(['SELF_EMPLOYED', 'EMPLOYED'])).optional(),
  lastUpdateIsoString: z.string().optional()
});

export const ManfreditesStatsSchema = z.object({
  hasEnoughManfredites: z.boolean(),
  stats: z
    .object({
      manfreditesCount: z.number().optional(),
      salariesHeatMap: z.object({
        salaryLabels: z.array(z.string()),
        experienceLabels: z.array(z.string()),
        heatMap: z.array(z.array(z.number()))
      }),
      remoteOptionsPercentages: z.object({
        remote: z.number(),
        hybrid: z.number(),
        onSite: z.number()
      }),
      manfredites: z.array(ManfreditesManfrediteStatsSchema)
    })
    .optional()
});

export type ManfreditesStats = z.infer<typeof ManfreditesStatsSchema>;
